import { PeriodTypeEnum } from '@/enums/period-type';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace ProductReuslt {
  export interface Product {
    productInfo: ProductInfo;
    userCredit: UserCredit;
    productSupplyFlag: boolean;
  }

  export interface ProductInfo {
    monthRate: number;
    periodList: number[];
    periodUnit: PeriodTypeEnum;
    rateUnit: PeriodTypeEnum;
    periodRates: number[];
    repaymentModel: RepaymentModel[];
    repaymentRate: number; // 提现超次利率
    minApplyAmount: number;
    everyMaxAmount: number; // 单比最大
    applyAmountStep: number;
    newRatio: number;
    FenUnit: string;
    FenRate: number;
    // 拍拍贷
    amountTerm: unknown[];
  }

  export interface UserCredit {
    availableAmount: number;
    productIconUrl: string;
    productId: string;
    productName: string;
    userId: string;
    bankName: string;
    bankNo: string;
    userBankCardId: string;
  }
}

export enum RepaymentModel {
  /** 等额本息 */
  EPAI = 'EPAI',
  /** 等额本金 */
  EP = 'EP',
  /** 等本等息 */
  EPAEI = 'EPAEI',
  /** 先息后本 */
  EFIRST = 'EFIRST',
  /** 等本等息2 */
  EPAEI_2 = 'EPAEI_2',
  /** 每月等额 */
  EPAEI_3 = 'EPAEI_3',
}

export const RepaymentModelToLabel: { [key: string]: string } = {
  [RepaymentModel.EPAI]: '等额本息',
  [RepaymentModel.EP]: '等额本金',
  [RepaymentModel.EPAEI]: '等本等费',
  [RepaymentModel.EFIRST]: '先息后本',
  [RepaymentModel.EPAEI_2]: '等本等息',
  [RepaymentModel.EPAEI_3]: '每月等额',
};

// 还款方式
export const RepayMentModelType: { [key: string]: string } = {
  2: 'EPAI',
  3: 'EP',
  1: 'EPAEI',
  4: 'EPAEI_3',
  5: 'EFIRST',
  6: 'EPAEI_2',
};

// 还款试算
export const repayPlanModelType: {[key: string]: string} = {
  EPAI: '2',
  EP: '3',
  EPAEI: '1',
  EPAEI_3: '4',
  EFIRST: '5',
  EPAEI_2: '6',
};

// 还款方式文案副标题
export const RepayMentTipsTitle: {[key: string]: string} = {
  EPAI: '每月还款金额相同',
  EP: '每月还款本金相同，利息递减',
};
